import * as React from 'react'
// hooks
import { useComponentRerender } from 'hooks/useComponentRerender'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  selectPlanItem: (value: any) => void
  removePlanItem: (nodeId: string) => void
  selectedPlanItems: any
}

export const SelectedPlanItemsContext = React.createContext<IContext>({} as any)

const SelectedPlanItems: React.FC<Props> = ({ children }) => {
  const selectedPlanItems = React.useRef([])

  const { rerender } = useComponentRerender()

  const handleSelect = (value) => {
    selectedPlanItems.current = [...selectedPlanItems.current, value]
    rerender()
  }

  const handleRemoveFromSelected = (nodeId) => {
    selectedPlanItems.current = selectedPlanItems.current.filter(({ id }) => id !== nodeId)
    rerender()
  }

  const value = {
    selectPlanItem: handleSelect,
    removePlanItem: handleRemoveFromSelected,
    selectedPlanItems: selectedPlanItems.current
  }

  return <SelectedPlanItemsContext.Provider value={value}>{children}</SelectedPlanItemsContext.Provider>
}

export default SelectedPlanItems
